#!/usr/bin/env node
import readline from 'readline';
import split from 'split';
import through from 'through';

import { log } from './log.js';
import { prettyRawLog } from './pretty/prettyRawLog.js';

if (process.env.LSK_LOG_READLINE !== '0') {
  readline
    .createInterface({
      // TODO: разоботаться почему
      // @ts-ignore
      input: process.stdin,
      // output: process.stdout,
    })
    .on('line', (raw) => {
      prettyRawLog(log, raw);
    });
} else {
  process.stdin
    .pipe(split())
    .pipe(
      through(function (raw) {
        if (!raw) {
          // @ts-ignore
          this.emit('data', `${raw}\n`);
          return;
        }
        prettyRawLog(log, raw);
      }),
    )
    // TODO: разоботаться почему
    // @ts-ignore
    .pipe(process.stdout);
}
